import { render } from "./ApprovedHoursModal.vue?vue&type=template&id=d35c044c"
import script from "./ApprovedHoursModal.vue?vue&type=script&lang=js"
export * from "./ApprovedHoursModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__